import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './GeneralInformation.module.scss';
import { ClockIcon, DocumentIcon, HashTagIcon, HouseIcon, LocationFilledIcon } from '../../../../../common/Icons';
import { distanceDateFormat, getFullLocationString } from '../../../../../../utils/helpers';
import InfoIcon from '../../../../../common/Icons/InfoIcon';
import { useWindowSize } from '../../../../../../utils/hooks';
import { responsiveSizeJobs } from '../../../../../../utils/constants';
import colors from '../../../../../../scss/colors';
import { OpenInFullOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const InformationItem = ({ text, color, children }) => {
  return (
    <li className={classes.infoItem} style={{ color }}>
      {children}
      <p>{text}</p>
    </li>
  );
};

const GeneralInformation = ({ isFullJobOpened, job, setHideRef = () => {} }) => {
  const ref = useRef(null);
  const { width, height } = useWindowSize();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getULHeight = () => {
    if (height < 600) {
      return '70px';
    }

    if (job.IsOpen) {
      return width > responsiveSizeJobs && height > 600 ? '216px' : '168px';
    }

    return width > responsiveSizeJobs ? '263px' : '208px';
  };

  useEffect(() => {
    setHideRef(ref);
  }, [ref]);

  return (
    <div className={classes.mainWrapper}>
      <div className='flex justify-between align-center w-full'>
        <p className={classes.title}>{job.JobTitle}</p>
        {!isFullJobOpened && (
          <Button onClick={() => navigate(`/jobs/${job.Id}`)} className={classes.openButton} variant='text'>
            <OpenInFullOutlined sx={{ color: colors.NAVY_BLUE }} />
          </Button>
        )}
      </div>
      {/* eslint-disable-next-line no-nested-ternary,max-len */}
      <ul style={{ height: getULHeight() }} ref={ref} className={classes.propList}>
        <InformationItem text={getFullLocationString(job.City, job.State, job.Country)}>
          <LocationFilledIcon />
        </InformationItem>
        <InformationItem text={job.Id}>
          <HashTagIcon />
        </InformationItem>
        <InformationItem text={job.Industry}>
          <HouseIcon />
        </InformationItem>
        <InformationItem text={job.JobType}>
          <DocumentIcon />
        </InformationItem>
        <InformationItem text={distanceDateFormat(job.PublishedDate)}>
          <ClockIcon />
        </InformationItem>
        {!job.IsOpen && (
          <InformationItem text={t('dashboard.jobs.closedAlert')} color={colors.RED_ERROR}>
            <InfoIcon color={colors.RED_ERROR} />
          </InformationItem>
        )}
      </ul>
    </div>
  );
};

export default GeneralInformation;
